// extracted by mini-css-extract-plugin
module.exports = {"AppLogo":"yoKK4OG6obG7ycymG8djM","AppLogoContainer":"_3LSDqF2AZHsMyTTn_hKJAt","AppLogo-spin":"_3254664jKrCMyW9IXVAxMl","AppHeader":"_34IkvEYp2p136EobP68sDB"};